import { Route, Routes } from "react-router";
import TransactionListPage from "./list";
import TransactionViewPage from "./view";

function TransactionsPage() {
	return (
		<Routes>
			<Route path="/" element={<TransactionListPage />} />
			<Route path="/:id" element={<TransactionViewPage />} />
		</Routes>
	);
}

export default TransactionsPage;
